import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Select, { StylesConfig } from 'react-select';
import { toast } from 'react-toastify';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import TextField from '../../../../core/common/textFields/TextField';
import { useCreateUpdateSpecificationExceptionMutation, useGetSpecificationExceptionQuery } from '../../../../services/EndPointsApis';
import { usePermission } from '../../../../core/hooks/PermissionHook';
import { constantsPermission } from '../../../../Config/Constants';
import * as Yup from 'yup';

const SpecificationExceptionTab = ({ projectLookups, projectId, showRibbon, storeProjectId }: any) => {
    //PermissionHook
    const { view: viewSpecificationException, edit: editSpecificationException, create: createSpecifiationException } = usePermission(constantsPermission?.moduleId?.specificationException);

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    // const ProjectId = useSelector((state: any) => state.common.projectId);
    const params = useParams()
    //Create Update Exception 
    const [UpsertException, { data, isError, error, isSuccess, isLoading }] = useCreateUpdateSpecificationExceptionMutation();
    //Get Exeption
    const { data: exceptionData, refetch, isLoading: isLoadingEcxeption } = useGetSpecificationExceptionQuery({ projectId: projectId || storeProjectId });

    const specificationExceptionSchema = Yup.object().shape({
        lst_ExceptionType: Yup.object().shape({
            id: Yup.number()
                .min(1, 'Exception Type is required')
                .required('Exception Type is required'),
        }),
        lst_ExceptionCategory: Yup.object().shape({
            id: Yup.number()
                .min(1, 'Exception Category is required')
                .required('Exception Category is required'),
        }),
        notes: Yup.string()
            .required("Note is required"),
    });



    const initialValues = {
        id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        projectId: projectId,
        lst_ExceptionType: {
            id: 0,
            value: ""
        },
        lst_ExceptionCategory: {
            id: 0,
            value: ""
        },
        amountImpacted: true,
        scopeImpacted: true,
        timelineImpacted: true,
        notes: ""
    }


    const formik = useFormik({
        initialValues,
        validationSchema: specificationExceptionSchema,
        onSubmit: (values) => {
            UpsertException({ ...values })
        },
    });

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
        }
        refetch()
    }, [isSuccess]);

    useEffect(() => {
        if (exceptionData?.result && Object.keys(exceptionData?.result).length > 0) {
            formik.setValues({ ...exceptionData?.result, projectId: projectId });
            // setDisabledata(true)
        } else {
            // setUpdateId(0);
        }
    }, [exceptionData]);
    return (
        <>
            {editSpecificationException &&
                <Ribbon
                    buttonText='Save'
                    buttonClass="add-popup ribbon-btn "
                    onClickbtn={formik.handleSubmit}
                />
            }
            <form onSubmit={formik.handleSubmit}
            >
                <div className='card'>
                    <div className='card-body p-3'>
                        <div className='row m-0'>
                            <div className='col-md-6'>
                                <label className='input-label'>Exception Type <span className="text-danger"> *</span> </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={projectLookups?.result?.Lst_ExceptionType?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                    value={
                                        formik.values?.lst_ExceptionType?.id
                                            ? {
                                                value: formik.values?.lst_ExceptionType?.id,
                                                label: formik.values?.lst_ExceptionType?.value || '',
                                            }
                                            : null
                                    }
                                    // isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_ExceptionType.id', selectedOption.value);
                                        formik.setFieldValue('lst_ExceptionType.value', selectedOption.label);
                                    }}
                                    onBlur={() => formik.setFieldTouched('lst_ExceptionType.id', true)}
                                />
                                {formik.submitCount > 0 && formik.values.lst_ExceptionCategory === null && (
                                    <div className="error"> ExceptionType is Required</div>

                                )}

                            </div>
                            <div className='col-md-6'>
                                <label className='input-label'>Exception Category <span className="text-danger"> *</span></label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={projectLookups?.result?.Lst_ExceptionCategory?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                    value={
                                        formik.values?.lst_ExceptionCategory?.id
                                            ? {
                                                value: formik.values?.lst_ExceptionCategory?.id,
                                                label: formik.values?.lst_ExceptionCategory?.value || '',
                                            }
                                            : null
                                    }
                                    // isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_ExceptionCategory.id', selectedOption.value);
                                        formik.setFieldValue('lst_ExceptionCategory.value', selectedOption.label);
                                    }}
                                    onBlur={() => formik.setFieldTouched('lst_ExceptionCategory.id', true)}

                                />
                                {formik.submitCount > 0 && formik.values.lst_ExceptionCategory === null && (
                                    <div className="error"> ExceptionCategory is Required</div>

                                )}
                                {/* {formik.errors.lst_ExceptionCategory &&
                                    <div className="error">{formik.errors.lst_ExceptionCategory.id}</div>
                                } */}
                            </div>
                            <div className='col-md-4'>
                                <label className="input-label">
                                    Amount Impacted?
                                </label>
                                <label className="checkboxs mt-1 mb-4">
                                    <input
                                        type="checkbox"
                                        checked={formik.values.amountImpacted}
                                        // disabled={viewOnly}
                                        {...formik.getFieldProps("amountImpacted")}
                                    />
                                    <span className="checkmarks" />
                                </label>
                            </div>
                            <div className='col-md-4'>
                                <label className="input-label">
                                    Scope Impacted?
                                </label>
                                <label className="checkboxs mt-1 mb-4">
                                    <input
                                        type="checkbox"
                                        checked={formik.values.scopeImpacted}
                                        // disabled={viewOnly}
                                        {...formik.getFieldProps("scopeImpacted")}
                                    />
                                    <span className="checkmarks" />
                                </label>
                            </div>
                            <div className='col-md-4'>
                                <label className="input-label">
                                    TimeLine Impacted?
                                </label>
                                <label className="checkboxs mt-1 mb-4">
                                    <input
                                        type="checkbox"
                                        checked={formik.values.timelineImpacted}
                                        // disabled={viewOnly}
                                        {...formik.getFieldProps("timelineImpacted")}
                                    />
                                    <span className="checkmarks" />
                                </label>
                            </div>
                            <div className='col-md-12'>
                                <div className="form-wrap">
                                    <TextField
                                        label="Note"
                                        type="text"
                                        {...formik.getFieldProps("notes")}
                                        required
                                    // disabled={viewOnly}
                                    />
                                    {formik.touched.notes && formik.errors.notes && (
                                        <div className="error">{formik.errors.notes}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>

    )
}

export default SpecificationExceptionTab